export const getOrgId = () => {
  try {
    const savedOrgId = localStorage.getItem('orgId');
    return savedOrgId ? parseInt(savedOrgId, 10) : null;
  } catch (error) {
    console.error('Error getting orgId:', error);
    return null;
  }
};
